import React from 'react';
import { Routes } from 'react-router-dom';

interface GatewayRoutesProps {
  children: React.ReactNode;
}

const GatewayRoutes = ({ children }: GatewayRoutesProps) => {
  return <Routes>{children}</Routes>;
};

export default GatewayRoutes;
